import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useContext as useUsersContext } from 'components/Users/Context';
import { Button } from 'react-bootstrap5';
import LinkPaymentMethodModal from '../LinkPaymentMethods/Index';

export default function Header({ policy }) {
  const { state: stateUsers } = useUsersContext();
  const [show, setShow] = useState(false);

  return (
    <div className="d-flex justify-content-between">
      <h4>Your Policy</h4>
      {policy && stateUsers.user && !stateUsers.user.attributes.specific.is_billing_manager && (
      <>
        <Button
          onClick={() => setShow(true)}
        >
          Link Plans to Payment Method
        </Button>
        <LinkPaymentMethodModal show={show} policy={policy} onHide={() => setShow(false)} />
      </>
      )}
    </div>
  );
}

Header.propTypes = {
  policy: PropTypes.object,
};

Header.defaultProps = {
  policy: null,
};
